
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"190.726","height":"177.142","viewBox":"0 0 50.463 46.869"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"matrix(1 0 -.25563 .96677 -70.842 -130.563)","fill-rule":"evenodd"}},[_c('rect',{attrs:{"width":"13.636","height":"22.862","rx":"2.273","ry":"2.294","x":"130.099","y":"135.291","pointer-events":"visiblePainted","fill":"#fff","stroke":"#000","stroke-width":".481"}}),_c('rect',{attrs:{"width":"9.091","height":"17.781","rx":"2.273","ry":"2.294","x":"132.371","y":"137.831","fill":"#55f"}})])])
          )
        }
      }
    